<section class="content">
  <app-input-text-chip [formData]="getEmailListInput()" />

  @if (hasEmailError) {
    <small class="error-text">
      {{ 'common.messages.error.invalid-email' | translateSafe }}
    </small>
  }
</section>

@if (this.isOverride()) {
  <section class="override">
    <div class="override-context">
      <span> {{ 'common.messages.alarm-rule.overrided' | translateSafe }} </span>
      <span> {{ 'common.messages.alarm-rule.default-value' | translateSafe }}:
        {{ getDefaultValueString }}
      </span>
    </div>

    <app-button-icon [iconName]="'replay'"
                     [label]="'common.actions.remove-override'"
                     [isTranslated]="true"
                     class="red"
                     (click)="removeOverride()" />
  </section>
}